module.exports = {
      id: "68a2f171257637e4a53e9cf9ca65049dstate-project.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#68a2f171257637e4a53e9cf9ca65049dstate-project.svg",
      toString: function () {
        return this.url;
      }
    }